import { get, post, put, patch } from "../../../services/api/Config"

// const _api_route = `menu-management`
const _api_route = `sitemap`

export function SearchContent(menuLevel, fromMenuId, { params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}`, params, lang })
}
export function GetContentById(menuLevel, fromMenuId, id, { params = {}, lang }) {
  console.log({lang})
  return get({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}/id/${id}`, params, lang })
}
export function CreateContent(menuLevel, fromMenuId, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}/create`, params, data, lang })
}
export function UpdateContent(menuLevel, fromMenuId, id, { params = {}, data = {} , lang }) {
  return put({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}/id/${id}`, params, data, lang })
}
export function PatchContent(menuLevel, fromMenuId, id, { params = {}, data = {}, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}/id/${id}`, params, data, lang })
}
export function DeleteContent(menuLevel, fromMenuId, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/${menuLevel}/${fromMenuId}/mutiDelete`, params, data, lang })
}
